import { componentName, PasswordStrengthClass } from './PasswordStrengthClass';

customElements.define(componentName, PasswordStrengthClass);

export { PasswordStrengthClass, componentName };
